import { Box, Button } from "@mui/material";
import enterpriseImg from "@src/shared/assets/enterprise.svg";

import styles from "./EnterpriseTariffBanner.module.scss";

interface Props {
  onClick: () => void;
}

export const EnterpriseTariffBanner = ({ onClick }: Props) => {
  return (
    <Box className={styles.banner}>
      <div className={styles.left}>
        <div className={styles.iconWrapper}>
          <img src={enterpriseImg} alt="" className={styles.icon} />
        </div>

        <div className={styles.content}>
          <h2 className={styles.title}>Расширенный</h2>
          <p className={styles.description}>
            Тариф предполагает персональный подход и полную интеграцию продукта
            с системой ATS On-Premise
          </p>
        </div>
      </div>

      <Button className={styles.button} onClick={onClick}>
        Подробнее / по запросу
      </Button>
    </Box>
  );
};